module.exports = __webpack_public_path__ + "static/media/2introIMG_3543.0032d361.jpg";